<template>
  <div>
      <div class="row">
          <div class="col-6">
              <div class="text-left section-title" style="padding: 5px;">
                  <span class="row-table-font-margins" style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center'>
                      <template v-if="buildingId">
                          <span row-table-font-margins style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center;'> {{ buildingName}} / </span>
                      </template>
                      Control Panel
                  </span>
              </div>
          </div>
          <div class="col-6 add-button-section">
              <div class="text-right" style="padding: 5px;">
                  <!--<span style="margin-right:5px">Add New Unit</span>
            <router-link class="btn btn-table" :to="{
      name: 'property',
      params: { buildingId: buildingId, buildingName: buildingName },
    }"><i class="fas fa-plus"></i></router-link>-->
                  <span @click="showSearch()"
                        style=" width: 30px; height: 30px; border-radius: 5px; background-color: #007DFC; color: white; display: inline-block; padding-left: 5px; padding-right: 5px; text-align: center; cursor: pointer; ">
                      <i class="fa fa-sliders-h" style="margin-top:7px;transform: rotate(-90deg);" aria-hidden="true"></i>
                  </span>

                  <period-select v-if="!visibleSearch" style="margin-left:-1px!important;border-left:0px;margin-right:8px;" class="select" id="period" name="period" :building-id="buildingId" v-model="period" />
                  <control-panel-add :building-id="buildingId" :period="period" :building-name="buildingName" />

                  <span @click="showSearch()"
                        style="
                          width: 30px;
                          height: 30px;
                          border-radius: 5px;
                          background-color: #007DFC;
                          color: white;
                          display: inline-block;
                          padding-left: 5px;
                          padding-right: 5px;
                          text-align: center;
                          cursor:pointer;

                          ">
                      <i class="fa fa-search" style="margin-top:7px;" aria-hidden="true"></i>
                  </span>
                  <span @click="exportToPDF()"
                        style="
width: 30px;
height: 30px;
border-radius: 5px;
background-color: #007DFC;
color: white;
display: inline-block;
padding-left: 5px;
padding-right: 5px;
text-align: center;
cursor:pointer;
margin-left:5px;
">
                      <i class="fa fa-file-export" style="margin-top:7px;" aria-hidden="true"></i>
                  </span>
                  <input type="text" v-if="visibleSearch" class="form-control" name="searchText" id="searchText" style=" display: inline-block; width: 250px; height: 30px;" v-model="filter">
                  <userMenu />
              </div>
          </div>
      </div>
      <!--<div class="col-md-12" style="margin-top: -10px;">
        <div
          style="
            height: 30px;
            line-height: 30px;
            padding-bottom: 32px;
            border-bottom: 2px #cbcbcb solid;
            margin-bottom: 20px;
          "
        >
          <p
            style="
              font-size: 15px;
              font-family: inherit;
              font-weight: 500;
              text-align: center;
              color: #015a6c;
              text-transform: uppercase;
            "
          >
            {{ buildingName }}
          </p>
        </div>
      </div>-->
   <div v-if="false" class="row">
      <div class="col-12">
        <div
          class="text-center section-title dark-green-title"
          style="margin-bottom: 20px; padding: 5px;"
        >
          <span
            class="white-font row-table-font-margins"
            style="
              font-size: 20px;
              font-family: inherit;
              font-weight: 400;
              line-height: 1;
              text-align: center;
            "
            >Statement of building</span
          >
        </div>
      </div>
    </div>

    

    <div class="row pull-center">
      <div class="col-2 offset-10 form-group">
      
      </div>
    </div>
      <div id="control-panel-admin">
    <statement
      v-if="buildingId"
      :building-id="buildingId"
      :building-name="buildingName"
      :key="period"
      :period="period"
               :filter="filter"
    ></statement>

    <div class="row">
        <!-- <div class="col-lg-1"></div>
        <div class="col-12 col-lg-10"> -->
        <div class="col-12">
            <GChart class="donutBorder"
                    type="LineChart"
                    :data="chartData"
                    :options="chartOptions"
                    ref="gChart" />
        </div>
    </div>
    </div>
  </div>
</template>

<script>
// $(document).ready(function(){
//     $('[data-toggle="tooltip"]').tooltip();
// });
    import { mapState } from "vuex";
    import html2pdf from "html2pdf.js"
export default {
  beforeCreate() {
    this.buildingId = this.$route.params.buildingId;
   // this.buildingName = this.$route.params.buildingName;
    //  alert(this.buildingId)
  },

  data: function () {
    return {
      period: 1,
      filter: "",
      buildingId: 0,
    //  buildingName: "",
      expensesMonth: [],
      totalFees: [],
      chartData: [],
      chartOptions: [],
      year: 0,
      visibleSearch: false,
    };
  },
  watch: {
    value(val) {
      this.$emit("update:buildingId", val);
    },
    buildingId(val) {
      this.value = val;
      //  this.fetchStatement();
    },
  },
  computed:{
    ...mapState({
      building: (state) => state.building.currentBuilding,
      buildings: (state) => state.building.buildings,
      numberOfAllowedBuildings: (state) =>
        state.building.numberOfAllowedBuildings,
    }),
    buildingName(){
      if(this.building != null)
        return  this.building.name;
      return ""
    },
  },
  mounted() {
    this.year = new Date().getFullYear();
    this.buildingId = this.$route.params.buildingId;
  //  this.buildingName = this.$route.params.buildingName;
    this.fetchStatement();
  },
  methods: {
    showSearch() {
      this.visibleSearch = !this.visibleSearch;
      },
          exportToPDF() {
          html2pdf(document.getElementById("control-panel-admin"), {
              margin: 1,
              filename: "control-panel.pdf",
              html2canvas: { scale: 2 },
              enableLinks: false,
              jsPDF: { orientation: 'landscape' }
          });
      },
    fetchStatement: function () {
      this.chartData = [];
      var request = "/statement";
      // if(this.route=="home")
      //   request = '/home/statment/get/';
      request = request + "?id=" + this.buildingId + "&period=" + this.period;
      this.$http
        .get(request, {
          id: this.buildingId,
        })
        .then(({ data }) => {
          this.mute = false;
          //this.contacts = data.contacts;
          this.mute = false;
          // let myObjStr = JSON.stringify(data.expenseFees);
          this.expensesMonth = data.expensesMonth;
          this.totalFees = data.totalFees;
          this.chartData.push(["Month", "Expenses", "Income"]);

          this.chartData.push([
            "Jan",
            this.expensesMonth[0],
            this.totalFees[0],
          ]);
          this.chartData.push([
            "Feb",
            this.expensesMonth[1],
            this.totalFees[1],
          ]);
          this.chartData.push([
            "Mar",
            this.expensesMonth[2],
            this.totalFees[2],
          ]);
          this.chartData.push([
            "Apr",
            this.expensesMonth[3],
            this.totalFees[3],
          ]);
          this.chartData.push([
            "May",
            this.expensesMonth[4],
            this.totalFees[4],
          ]);
          this.chartData.push([
            "Jun",
            this.expensesMonth[5],
            this.totalFees[5],
          ]);
          this.chartData.push([
            "Jul",
            this.expensesMonth[6],
            this.totalFees[6],
          ]);
          this.chartData.push([
            "Aug",
            this.expensesMonth[7],
            this.totalFees[7],
          ]);
          this.chartData.push([
            "Sep",
            this.expensesMonth[8],
            this.totalFees[8],
          ]);
          this.chartData.push([
            "Oct",
            this.expensesMonth[9],
            this.totalFees[9],
          ]);
          this.chartData.push([
            "Nov",
            this.expensesMonth[10],
            this.totalFees[10],
          ]);
          this.chartData.push([
            "Dec",
            this.expensesMonth[11],
            this.totalFees[11],
          ]);
          this.chartOptions = {
            chart: {
              title: "Statement for year " + this.year,
              /*'subtitle': "Sales, Expenses, and Profit: 2014-2017"*/
            },
            title: "Statement for year " + this.year,
            colors: ["#212121", "#007DFC"],
            chartArea: {
              left: 40,
              width: "85%",
            },
            // legend: { position: 'top' },
            pointSize: "7",
          };
        });
    },
    changed: function () {
      this.fetchStatement();
    },
  },
};
</script>
